import { configureStore } from '@reduxjs/toolkit';
import headerSlice from '../features/common/headerSlice';
import modalSlice from '../features/common/modalSlice';
import rightDrawerSlice from '../features/common/rightDrawerSlice';
import tableSlice from '../features/table/tableSlice';
import scheduleEditorSlice from '../features/common/templateEditorSlice';
import athleteGroupScheduleSlice from '../features/common/athleteGroupScheduleSlice';
import questionnaireSlice from '../features/common/questionnaireSlice';
import utilSlice from '../features/common/utilSlice';
import messagesSlice from '../features/common/messagesSlice';
import formPersistenceSlice from '../features/common/formPersistenceSlice';
import onboardingSlice from '../features/common/onboardingSlice';
import widgetVisibilitySlice from '../features/common/widgetVisibilitySlice';
import workoutCustomizationReducer from '../features/scheduleeditor/workoutCustomizationSlice';

const combinedReducer = {
	header: headerSlice,
	table: tableSlice,
	rightDrawer: rightDrawerSlice,
	modal: modalSlice,
	messages: messagesSlice,
	questionnaire: questionnaireSlice,
	util: utilSlice,
	scheduleEditor: scheduleEditorSlice,
	athleteGroupSchedule: athleteGroupScheduleSlice,
	formPersistence: formPersistenceSlice,
	onboarding: onboardingSlice,
	widgetVisibility: widgetVisibilitySlice,
	workoutCustomization: workoutCustomizationReducer,
};

export default configureStore({
	reducer: combinedReducer,
});
